export const white = '#FFFFFF';
export const beige = '#FFF2E1';
export const orange = '#F88D58';
export const lightOrange = '#FFBB8A';
export const darkOrange = '#C06A3E';
export const gray = '#4D4D4D';
export const lightGray = '#6F6F6F';
export const darkGray = '#323232';
export const purple = '#5F23FF';
export const lightPurple = '#FBF5FF';
export const darkRoyalBlue = '#0A2855';
